import { ThemeProvider } from '@emotion/react';
import { Box, Grid, Typography } from '@mui/material';
import { createTheme, styled } from '@mui/material/styles';
import { getFeaturedUsers } from 'APIs/UserDataApi';
import Loader from 'components/atoms/loader';
import ArtistCard from 'components/molecules/Card/ArtistCard';
import { UserData } from 'interfaces/UserData.interface';
import * as React from 'react';

const colortheme = createTheme({
  palette: {
    primary: {
      main: '#292739',
    },
    secondary: {
      main: '#36899f',
    },
  },
  typography: {
    fontFamily: ['lato'].join(','),
  },
});

const MainGrid = styled(Grid)(({ theme }) => ({
  margin: '0rem',
  marginTop: '8rem',
}));

const HeadingText = styled(Typography)(({ theme }) => ({
  margin: '3rem 0rem',
  fontSize: '2rem',
  color: '#fff',
}));

const FeaturedArtistsBody = () => {
  const [users, setUsers] = React.useState<UserData[]>([]);
  const [loading, setLoading] = React.useState<boolean>(false);
  React.useEffect(() => {
    const fetchUsers = async () => {
      setLoading(true);
      const res = await getFeaturedUsers();
      setUsers([...res.data]);
      setLoading(false);
    };
    fetchUsers();
  }, []);
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <React.Fragment>
      <ThemeProvider theme={colortheme}>
        <MainGrid
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
          container
        >
          <Grid
            item
            xs={12}
            style={{ padding: '0rem 2rem', alignSelf: 'flex-start' }}
          >
            <HeadingText>Featured Artists</HeadingText>
          </Grid>
          <Box
            sx={{
              display: 'flex',
              flexWrap: 'wrap',
              justifyContent: 'center',
              width: '80%',
            }}
          >
            {loading ? (
              <div style={{ height: '600px' }}>
                <Loader />{' '}
              </div>
            ) : (
              users.map(user => {
                return (
                  <Grid
                    item
                    key={user.id}
                    xs={12}
                    sm={6}
                    md={4}
                    style={{
                      padding: '10px',
                      display: 'flex',
                      justifyContent: 'center',
                    }}
                  >
                    <ArtistCard data={user} />
                  </Grid>
                );
              })
            )}
          </Box>
        </MainGrid>
      </ThemeProvider>
    </React.Fragment>
  );
};

export default FeaturedArtistsBody;
